import React, { useState } from 'react';
import { Card, Form, Input, InputNumber, Button, Typography, Alert } from 'antd';
import { SearchOutlined, FileTextOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const AutofacturaLanding: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values: { code: string; orderNumber: string; total: number }) => {
    setLoading(true);
    const code = values.code.trim().toUpperCase();
    const orderNumber = values.orderNumber.trim();
    const total = values.total.toFixed(2);
    navigate(`/autofactura/${code}?order=${orderNumber}&total=${total}`);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        padding: 16,
      }}
    >
      <Card
        style={{
          maxWidth: 440,
          width: '100%',
          borderRadius: 12,
          boxShadow: '0 4px 24px var(--shadow-color)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <FileTextOutlined style={{ fontSize: 48, color: 'var(--color-primary)', marginBottom: 12 }} />
          <Title level={3} style={{ margin: 0 }}>
            Autofacturación
          </Title>
          <Paragraph type="secondary" style={{ marginTop: 8 }}>
            Genera la factura de tu consumo ingresando los datos de tu ticket.
          </Paragraph>
        </div>

        <Form layout="vertical" onFinish={handleSubmit} size="large">
          <Form.Item
            label="Código del restaurante"
            name="code"
            rules={[
              { required: true, message: 'Ingresa el código del restaurante' },
              { max: 10, message: 'El código no puede tener más de 10 caracteres' },
            ]}
          >
            <Input
              placeholder="Ej: R7X3K"
              style={{ textTransform: 'uppercase' }}
              maxLength={10}
            />
          </Form.Item>

          <Form.Item
            label="Número de orden"
            name="orderNumber"
            rules={[
              { required: true, message: 'Ingresa el número de orden' },
              {
                pattern: /^\d+$/,
                message: 'Solo se permiten números',
              },
            ]}
          >
            <Input placeholder="Ej: 42" maxLength={10} />
          </Form.Item>

          <Form.Item
            label="Total de tu cuenta"
            name="total"
            rules={[
              { required: true, message: 'Ingresa el total de tu cuenta' },
            ]}
            extra="Ingresa el total exacto que aparece en tu ticket"
          >
            <InputNumber
              placeholder="Ej: 1256.50"
              min={0.01}
              precision={2}
              prefix="$"
              style={{ width: '100%' }}
              controls={false}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              icon={<SearchOutlined />}
              style={{ backgroundColor: 'var(--color-primary)', borderColor: 'var(--color-primary)' }}
            >
              Buscar mi orden
            </Button>
          </Form.Item>
        </Form>

        <Alert
          type="info"
          showIcon
          icon={<InfoCircleOutlined />}
          message="¿Tienes problemas para facturar o necesitas ayuda? Contacta directamente al restaurante donde realizaste tu consumo."
          style={{ marginBottom: 0 }}
        />
      </Card>
    </div>
  );
};

export default AutofacturaLanding;
